import { CalendarEvent } from '@chilipiper/scheduling-shared'
import React, { createContext } from 'react'
import { useSetState } from 'react-use'
import { Storage } from '../../utils/storage'

export interface State {
  isNavExpanded: boolean
  weekEvents: CalendarEvent[]
  workingHours: CalendarEvent[]
}

interface GlobalStateValue {
  globalState: State
  setGlobalState: (state: Partial<State>) => void
}

export const GlobalContext = createContext({} as GlobalStateValue)

interface Props {
  children: React.ReactNode
  initialState?: Partial<State>
}

export const GlobalStateProvider = ({ children, initialState }: Props) => {
  const isNavExpanded = Storage.get('LEFTNAV_STATE') === 'expanded'
  const [state, setState] = useSetState<State>({
    isNavExpanded,
    workingHours: [],
    weekEvents: [],
    ...initialState,
  })

  const contextValue = {
    globalState: state,
    setGlobalState: setState,
  }

  return <GlobalContext value={contextValue}>{children}</GlobalContext>
}
